import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  margin-top: 2.5rem;
`

interface PageBodyContainerProps {
  children: React.ReactNode
}

const PageBodyContainer = ({ children }: PageBodyContainerProps) => {
  return <Container>{children}</Container>
}

export default PageBodyContainer
